var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vss-card"},[_c('div',{staticClass:"header-box"},[_vm._t("header"),_vm._v(" "),_c('div',{staticClass:"operate"},[_vm._t("operate")],2)],2),_vm._v(" "),_c('div',{staticClass:"card-content-box"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }